<template>
    <div class="relative flex min-h-full flex-col">
        <!-- Results -->
        <div v-if="results.isLoading || results.showResultsPage">
            <div class="relative flex flex-col">
                <!-- Modal content -->
                <div>
                    <div v-if="results.isLoading" class="mt-2.5">Skeleton</div>
                    <div
                        v-if="!results.isLoading"
                        class="overflow-auto rounded md:scrollbar md:scrollbar-thin md:scrollbar-track-transparent md:scrollbar-thumb-slate-300"
                    >
                        <div class="h-96 overflow-auto">
                            <ul>
                                <!-- added creators -->
                                <li
                                    v-for="creator in results.resultsType === 'list'
                                        ? results.lists.addedCreators
                                        : results.campaigns.addedCreators"
                                    :key="creator._id"
                                    class="flex items-center border-b px-5 py-2"
                                >
                                    <div class="flex-grow">
                                        <div class="flex">
                                            <div class="relative mr-2 shrink-0 sm:mr-3">
                                                <Avatar
                                                    class="bg-slate-700 text-slate-50"
                                                    :src="creator.superview.normalized.avatar_url"
                                                    :username="creator.superview.normalized.display_name"
                                                    :size="32"
                                                />

                                                <div
                                                    v-if="creator.superview.platform_id === 'twitch'"
                                                    class="absolute -bottom-2 -right-1.5 z-10 flex rounded-full"
                                                >
                                                    <svg
                                                        width="22"
                                                        height="22"
                                                        fill="none"
                                                        class="flex-shrink-0 fill-current"
                                                    >
                                                        <path
                                                            fill="#fff"
                                                            d="M7.95243 3.33337 4.3999 6.8859v11.3999h2.85715v5.2093l5.20935-5.2093h1.9048l5.4573-5.4573V3.33337H7.95243Z"
                                                        />
                                                        <path
                                                            fill="#9147FF"
                                                            d="M8.78086 5.33337 6.3999 7.71433v8.57147h2.85714v2.3809l2.38096-2.3809h1.9048L17.8285 12V5.33337H8.78086Z"
                                                        />
                                                        <path
                                                            fill="#fff"
                                                            d="m14.9711 13.4286 1.9048-1.9048V6.28574H9.25684v7.14286h1.90476v1.9048l1.9048-1.9048h1.9047Z"
                                                        />
                                                        <path
                                                            fill="#9147FF"
                                                            d="M12.1143 8.19037h.9523v2.85713h-.9523V8.19037Zm3.3333 0v2.85713h-.9524V8.19037h.9524Z"
                                                        />
                                                    </svg>
                                                </div>
                                                <div
                                                    v-else-if="creator.superview.platform_id === 'youtube'"
                                                    class="absolute -bottom-0.5 -right-1 z-10 flex rounded-full"
                                                >
                                                    <svg height="16" width="16" viewBox="0 0 490 490">
                                                        <g>
                                                            <g>
                                                                <path
                                                                    fill="#EA4640"
                                                                    d="M480,180v130c0,55.195-44.805,100-100,100H110c-55.195,0-100-44.805-100-100V180
                                            c0-55.199,44.805-100,100-100h270C435.195,80,480,124.801,480,180z"
                                                                />
                                                            </g>
                                                            <g>
                                                                <g>
                                                                    <polygon
                                                                        style="fill: #ffffff"
                                                                        points="320,245 200,295 200,195 "
                                                                    />
                                                                </g>
                                                                <g>
                                                                    <path
                                                                        fill="white"
                                                                        d="M380,70H110C49.346,70,0,119.346,0,180v130c0,60.654,49.346,110,110,110h270
                                                c60.654,0,110-49.346,110-110V180C490,119.346,440.654,70,380,70z M470,310c0,49.626-40.374,90-90,90H110
                                                c-49.626,0-90-40.374-90-90V180c0-49.626,40.374-90,90-90h270c49.626,0,90,40.374,90,90V310z"
                                                                    />
                                                                    <path
                                                                        fill="white"
                                                                        d="M323.846,235.769l-120-50c-3.085-1.286-6.611-0.945-9.393,0.911
                                                c-2.782,1.854-4.453,4.977-4.453,8.32v100c0,3.344,1.671,6.466,4.453,8.32c1.667,1.112,3.601,1.68,5.548,1.68
                                                c1.301,0,2.608-0.254,3.845-0.769l120-50c3.727-1.553,6.154-5.194,6.154-9.231S327.572,237.322,323.846,235.769z M210,280v-70
                                                l84,35L210,280z"
                                                                    />
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="flex grow">
                                                <div class="my-auto flex grow">
                                                    <span class="font-semibold">{{
                                                        creator.superview.normalized.display_name
                                                    }}</span>
                                                    <span class="ml-auto text-sm text-emerald-600">Added</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <!-- duplicate creators -->
                                <li
                                    v-for="creator in results.resultsType === 'list'
                                        ? results.lists.duplicateCreators
                                        : results.campaigns.duplicateCreators"
                                    :key="creator._id"
                                    class="flex items-center border-b px-5 py-2"
                                >
                                    <div class="flex-grow">
                                        <div class="flex">
                                            <div class="relative mr-2 shrink-0 sm:mr-3">
                                                <Avatar
                                                    class="bg-slate-700 text-slate-50"
                                                    :src="creator.superview.normalized.avatar_url"
                                                    :username="creator.superview.normalized.display_name"
                                                    :size="32"
                                                />
                                                <div
                                                    v-if="creator.superview.platform_id === 'twitch'"
                                                    class="absolute -bottom-2 -right-1.5 z-10 flex rounded-full"
                                                >
                                                    <svg
                                                        width="22"
                                                        height="22"
                                                        fill="none"
                                                        class="flex-shrink-0 fill-current"
                                                    >
                                                        <path
                                                            fill="#fff"
                                                            d="M7.95243 3.33337 4.3999 6.8859v11.3999h2.85715v5.2093l5.20935-5.2093h1.9048l5.4573-5.4573V3.33337H7.95243Z"
                                                        />
                                                        <path
                                                            fill="#9147FF"
                                                            d="M8.78086 5.33337 6.3999 7.71433v8.57147h2.85714v2.3809l2.38096-2.3809h1.9048L17.8285 12V5.33337H8.78086Z"
                                                        />
                                                        <path
                                                            fill="#fff"
                                                            d="m14.9711 13.4286 1.9048-1.9048V6.28574H9.25684v7.14286h1.90476v1.9048l1.9048-1.9048h1.9047Z"
                                                        />
                                                        <path
                                                            fill="#9147FF"
                                                            d="M12.1143 8.19037h.9523v2.85713h-.9523V8.19037Zm3.3333 0v2.85713h-.9524V8.19037h.9524Z"
                                                        />
                                                    </svg>
                                                </div>
                                                <div
                                                    v-else-if="creator.superview.platform_id === 'youtube'"
                                                    class="absolute -bottom-0.5 -right-1 z-10 flex rounded-full"
                                                >
                                                    <svg height="16" width="16" viewBox="0 0 490 490">
                                                        <g>
                                                            <g>
                                                                <path
                                                                    fill="#EA4640"
                                                                    d="M480,180v130c0,55.195-44.805,100-100,100H110c-55.195,0-100-44.805-100-100V180
                                            c0-55.199,44.805-100,100-100h270C435.195,80,480,124.801,480,180z"
                                                                />
                                                            </g>
                                                            <g>
                                                                <g>
                                                                    <polygon
                                                                        style="fill: #ffffff"
                                                                        points="320,245 200,295 200,195 "
                                                                    />
                                                                </g>
                                                                <g>
                                                                    <path
                                                                        fill="white"
                                                                        d="M380,70H110C49.346,70,0,119.346,0,180v130c0,60.654,49.346,110,110,110h270
                                                c60.654,0,110-49.346,110-110V180C490,119.346,440.654,70,380,70z M470,310c0,49.626-40.374,90-90,90H110
                                                c-49.626,0-90-40.374-90-90V180c0-49.626,40.374-90,90-90h270c49.626,0,90,40.374,90,90V310z"
                                                                    />
                                                                    <path
                                                                        fill="white"
                                                                        d="M323.846,235.769l-120-50c-3.085-1.286-6.611-0.945-9.393,0.911
                                                c-2.782,1.854-4.453,4.977-4.453,8.32v100c0,3.344,1.671,6.466,4.453,8.32c1.667,1.112,3.601,1.68,5.548,1.68
                                                c1.301,0,2.608-0.254,3.845-0.769l120-50c3.727-1.553,6.154-5.194,6.154-9.231S327.572,237.322,323.846,235.769z M210,280v-70
                                                l84,35L210,280z"
                                                                    />
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="flex grow">
                                                <div class="my-auto flex grow">
                                                    <span class="font-semibold">{{
                                                        creator.superview.normalized.display_name
                                                    }}</span>
                                                    <span class="ml-auto text-sm text-rose-600">Duplicate</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else-if="!state.lists.isLoaded || !isProfileUnlocksLoaded">
            <SkeletonAddToMenu />
        </div>

        <div v-else>
            <!-- Profile Unlock Info -->
            <div
                v-if="isLegacyBilling !== true"
                class="mx-5 rounded border px-4 py-2 text-sm"
                :class="!canUnlockProfiles ? 'border-rose-200 bg-rose-100' : 'border-slate-200 bg-slate-100 '"
            >
                <div v-if="!canUnlockProfiles">
                    <p>
                        You currently only have
                        <span class="font-semibold">{{ remainingProfileUnlockQuota }} profile unlock</span>
                        credits available, adding these creators would require up to
                        <span class="font-semibold">{{ lockedProfiles }} profile unlock</span>
                        credits.
                    </p>
                </div>
                <div v-else>
                    <p>
                        You will use up to
                        <span class="font-semibold">{{ lockedProfiles }} profile unlock</span>
                        credits to add these creators out of your plans
                        <span class="font-semibold">{{ remainingProfileUnlockQuota }}</span>
                        remaining
                        <span class="font-semibold">profile unlock</span>
                        credits.
                    </p>
                </div>
            </div>

            <!-- Selected Creators -->
            <div class="px-5 pt-4 mb-6">
                <h2 class="text-sm font-semibold text-slate-700 mb-3">
                    Selected Creators
                </h2>

                <div class="mt-3 flex max-h-[72px] flex-wrap overflow-y-auto">
                    <div v-for="superview in superviews" :key="superview._id" class="mb-1 mr-2">
                        <NamePlate
                            :logo="superview.normalized.avatar_url"
                            :name="superview.normalized.name"
                            :display-name="superview.normalized.display_name"
                            :platform-id="platformId"
                            :platform-user-id="superview._id"
                            :is-drawer-enabled="false"
                        />
                    </div>
                </div>
            </div>

            <!-- Platform Selection -->
            <div class="px-5 mb-6">
                <h2 class="text-sm font-semibold text-slate-700 mb-2">
                    Creator Platform Selection
                </h2>

                <p class="text-sm text-slate-600 mb-4">
                    <span class="font-semibold text-slate-900">{{ totalProfilesSelected }}</span>
                    creator profile<span v-if="totalProfilesSelected !== 1">s</span> will be added.
                </p>

                <div class="grid grid-cols-2 lg:grid-cols-4 gap-2 mb-4 px-5 py-3 rounded border border-slate-200">
                    <label class="flex items-center space-x-2 text-sm text-slate-800">
                    <input
                        v-model="isAllPlatformsChecked"
                        type="checkbox"
                        class="h-4 w-4 text-blue-600 border-slate-300 rounded focus:ring-blue-500"
                    />
                        <span>All Platforms</span>
                    </label>

                    <label
                        v-for="platform in availablePlatforms"
                        :key="platform"
                        class="flex items-center space-x-2 text-sm text-slate-800"
                    >
                        <input
                            v-model="selectedPlatforms"
                            type="checkbox"
                            class="h-4 w-4 text-blue-600 border-slate-300 rounded focus:ring-blue-500"
                            :value="platform"
                        />
                        <span class="capitalize">{{ platform }}</span>
                    </label>
                </div>
            </div>

            <div class="px-5">
                <div class="flex justify-end">
                    <div
                        class="inline-flex w-full lg:w-auto rounded bg-slate-200 p-1"
                        role="group"
                    >
                        <button
                            v-for="tab in tabs"
                            :key="tab"
                            class="flex grow rounded px-3 py-2 sm:px-4 font-semibold leading-tight transition duration-150 ease-in-out focus:outline-none focus:ring-0 hover:text-foreground"
                            :class="{
                                'bg-white text-foreground': state.activeTab === tab,
                            }"
                                @click.prevent="setActiveTab(tab)"
                            >
                            <span class="mx-auto text-sm capitalize">{{ tab }}</span>
                        </button>
                    </div>
                </div>

                <div v-if="state.activeTab !== 'recents'" class="mt-2 border-slate-200">
                    <div class="relative">
                        <label for="action-search" class="sr-only">Search</label>

                        <input
                            id="action-search"
                            v-model="state.searchText"
                            class="form-input w-full pl-9 shadow-none focus:border-slate-300"
                            type="search"
                            :placeholder="`Search for ${state.activeTab}`"
                            autocomplete="off"
                        />

                        <div class="group absolute inset-0 right-auto" aria-label="Search">
                            <svg
                                class="ml-3 mr-2 mt-2.5 h-4 w-4 shrink-0 fill-current text-slate-400 group-hover:text-slate-500"
                                viewBox="0 0 16 16"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z"
                                />
                                <path
                                    d="M15.707 14.293L13.314 11.9a8.019 8.019 0 01-1.414 1.414l2.393 2.393a.997.997 0 001.414 0 .999.999 0 000-1.414z"
                                />
                            </svg>
                        </div>
                    </div>
                </div>

                <!-- Recent -->
                <div
                    v-if="state.activeTab === 'recents'"
                    class="mt-2 overflow-hidden overflow-y-auto rounded border border-slate-200"
                >
                    <div class="h-96 text-sm">
                        <div v-for="item in mappedRecents.items" :key="item.id" class="border-b border-slate-200">
                            <div v-if="item.type === 'supercampaign'">
                                <div
                                    class="group p-3 font-semibold"
                                    :class="{
                                        'bg-slate-50':
                                            state.activeSupercampaignId === mappedRecents.supercampaigns[item.id],
                                        'cursor-pointer hover:bg-slate-100': state.activeSupercampaignId !== item.id,
                                    }"
                                    @click="handleSuperCampaignClick(item.id)"
                                >
                                    <div class="flex">
                                        <div class="relative mr-3 h-16 w-12 shrink-0 rounded bg-slate-200">
                                            <img
                                                v-if="mappedRecents.supercampaigns[item.id].game"
                                                class="absolute h-full w-full rounded object-cover object-center"
                                                :src="`https://static-cdn.jtvnw.net/ttv-boxart/${
                                                    mappedRecents.supercampaigns[item.id].game.twitch_id
                                                }_IGDB-288x384.jpg`"
                                            />
                                            <div v-else class="flex h-full w-full">
                                                <span class="m-auto block text-center text-xs leading-4"
                                                    >No<br />Box<br />Art</span
                                                >
                                            </div>
                                        </div>

                                        <div class="my-auto">
                                            <div
                                                v-if="mappedRecents.supercampaigns[item.id].title"
                                                class="mb-1 line-clamp-2"
                                            >
                                                {{ mappedRecents.supercampaigns[item.id].title }}
                                            </div>
                                            <div
                                                class="inline-flex rounded bg-slate-100 px-2 py-1 text-center text-xs font-medium group-hover:bg-slate-200"
                                            >
                                                {{ mappedRecents?.supercampaigns?.[item.id]?.stage }}
                                            </div>
                                            <div
                                                class="ml-2 inline-flex rounded bg-slate-100 px-2 py-1 text-center text-xs font-medium group-hover:bg-slate-200"
                                            >
                                                Created
                                                {{
                                                    $filters.formatDate(
                                                        mappedRecents?.supercampaigns?.[item.id]?.created_at,
                                                    )
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-show="state.activeSupercampaignId === item.id">
                                    <div
                                        v-for="campaign in mappedRecents.supercampaigns[item.id].campaigns"
                                        :key="campaign.id"
                                        class="relative flex justify-between border-t border-slate-200 px-6 py-2"
                                    >
                                        <div class="flex">
                                            <div class="flex">
                                                <AppIcon
                                                    class="my-auto mr-3 h-6 w-6"
                                                    :name="getFromDictionary(`campaign.type.${campaign.type}`, 'icon')"
                                                />
                                            </div>

                                            <div class="flex flex-col">
                                                <span class="font-medium text-slate-600">{{
                                                    getFromDictionary(`campaign.type.${campaign.type}`, 'label')
                                                }}</span>
                                                <div v-if="campaign.started_at" class="text-xs">
                                                    {{ $filters.moment(campaign.started_at).format('MMM Do, YYYY') }}
                                                </div>
                                            </div>
                                        </div>
                                        <Button
                                            v-if="campaign?.is_add_in_progress === true"
                                            disabled
                                        >
                                            <AppIcon
                                                class="my-auto mr-2 h-4 w-4 animate-spin"
                                                name="spinner-third"
                                            />
                                            <span>Adding</span>
                                        </Button>
                                        <Button
                                            v-else-if="!isMulti && isCreatorAdded('campaign', campaign.id, item.id)"
                                            disabled
                                        >
                                            <AppIcon class="my-auto mr-2 h-4 w-4" name="check" />
                                            <span>Added</span>
                                        </Button>
                                        <Button
                                            v-else-if="
                                                !isMulti && isCreatorAlreadyAdded('campaign', campaign.id, item.id)
                                            "
                                            disabled
                                        >
                                            <AppIcon class="my-auto mr-2 h-4 w-4" name="check" />
                                            <span>In Campaign</span>
                                        </Button>

                                        <Button
                                            v-else
                                            :disabled="!canUnlockProfiles || totalProfilesSelected === 0"
                                            @click="onCampaignSelect(campaign)"
                                        >
                                            <AppIcon class="my-auto mr-2 h-4 w-4" name="plus" />
                                            <span>Add</span>
                                        </Button>
                                    </div>

                                    <div
                                        v-if="
                                            !mappedRecents.supercampaigns[item.id].campaigns ||
                                            !mappedRecents.supercampaigns[item.id].campaigns.length
                                        "
                                        class="w-full border-t border-slate-200 px-6 py-2 text-center"
                                    >
                                        <p>This campaign has no modules yet</p>
                                    </div>
                                </div>
                            </div>

                            <div v-else-if="item.type === 'list'">
                                <div class="px-5 py-3">
                                    <div class="flex items-center justify-between">
                                        <div class="flex">
                                            <div class="my-auto">
                                                <div
                                                    v-if="mappedRecents.lists[item.id].name"
                                                    class="line-clamp-2 font-semibold"
                                                >
                                                    {{ mappedRecents.lists[item.id].name }}
                                                </div>
                                                <div class="text-xs">
                                                    {{ mappedRecents.lists[item.id]?.totals?.total }} creators
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <Button
                                                v-if="!isMulti && mappedRecents.lists[item.id].creatorIsOnList"
                                                disabled
                                            >
                                                <AppIcon
                                                    class="my-auto mr-2 h-4 w-4"
                                                    name="check"
                                                />
                                                <span>In List</span>
                                            </Button>
                                            <Button
                                                v-else-if="mappedRecents.lists[item.id]?.is_add_in_progress === true"
                                                disabled
                                            >
                                                <AppIcon
                                                    class="my-auto mr-2 h-4 w-4 animate-spin"
                                                    name="spinner-third"
                                                />
                                                <span>Adding</span>
                                            </Button>

                                            <Tooltip
                                                v-else
                                                max-width="500"
                                                :show-tooltip="
                                                    mappedRecents.lists[item.id].totals.total !== -1 &&
                                                    getLimitation('lists.size') !== null &&
                                                    superviews.length + mappedRecents.lists[item.id].totals.total >
                                                        getLimitation('lists.size')
                                                "
                                            >
                                                <template #trigger>
                                                    <Button
                                                        size="sm"
                                                        :disabled="
                                                            (mappedRecents.lists[item.id].totals.total !== -1 &&
                                                            getLimitation('lists.size') !== null &&
                                                            superviews.length +
                                                                mappedRecents.lists[item.id].totals.total >
                                                                getLimitation('lists.size')) || !canUnlockProfiles || totalProfilesSelected === 0
                                                        "
                                                        @click="handleAddClick(mappedRecents.lists[item.id])"
                                                    >
                                                        <AppIcon
                                                            class="my-auto mr-1.5 h-4 w-4"
                                                            name="plus"
                                                        />
                                                        <span>Add</span>
                                                    </Button>
                                                </template>
                                                <template #default>
                                                    {{
                                                        getFromDictionary(`usage.lists.size`).replace(
                                                            '[LIMIT]',
                                                            getLimitation('lists.size'),
                                                        )
                                                    }}
                                                </template>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="!mappedRecents.total" class="py-3 text-center text-sm">No Recents</div>
                    </div>
                </div>

                <!-- Campaigns -->
                <div
                    v-if="state.activeTab === 'campaigns'"
                    class="mt-2 overflow-hidden overflow-y-scroll rounded border border-slate-200"
                >
                    <div class="h-96 divide-y divide-slate-200 text-sm">
                        <div v-for="supercampaign in filteredSupercampaigns" :key="supercampaign.id">
                            <div
                                class="group p-3 font-semibold"
                                :class="{
                                    'bg-slate-50': state.activeSupercampaignId === supercampaign.id,
                                    'cursor-pointer hover:bg-slate-100':
                                        state.activeSupercampaignId !== supercampaign.id,
                                }"
                                @click="handleSuperCampaignClick(supercampaign.id)"
                            >
                                <div class="flex">
                                    <div class="relative mr-3 h-16 w-12 shrink-0 rounded bg-slate-200">
                                        <img
                                            v-if="supercampaign.game"
                                            class="absolute h-full w-full rounded object-cover object-center"
                                            :src="`https://static-cdn.jtvnw.net/ttv-boxart/${supercampaign.game.twitch_id}_IGDB-288x384.jpg`"
                                        />
                                        <div v-else class="flex h-full w-full">
                                            <span class="m-auto block text-center text-xs leading-4"
                                                >No<br />Box<br />Art</span
                                            >
                                        </div>
                                    </div>

                                    <div class="my-auto">
                                        <div v-if="supercampaign.title" class="mb-1 line-clamp-2">
                                            {{ supercampaign.title }}
                                        </div>
                                        <div
                                            class="inline-flex rounded bg-slate-100 px-2 py-1 text-center text-xs font-medium group-hover:bg-slate-200"
                                        >
                                            {{ supercampaign?.stage }}
                                        </div>
                                        <div
                                            class="ml-2 inline-flex rounded bg-slate-100 px-2 py-1 text-center text-xs font-medium group-hover:bg-slate-200"
                                        >
                                            Created {{ $filters.formatDate(supercampaign?.created_at) }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-show="state.activeSupercampaignId === supercampaign.id">
                                <div
                                    v-for="campaign in supercampaign.campaigns"
                                    :key="campaign.id"
                                    class="relative flex justify-between border-t border-slate-200 px-6 py-2"
                                >
                                    <div class="flex">
                                        <div class="flex">
                                            <AppIcon
                                                class="my-auto mr-3 h-6 w-6"
                                                :name="getFromDictionary(`campaign.type.${campaign.type}`, 'icon')"
                                            />
                                        </div>

                                        <div class="flex flex-col">
                                            <span class="font-medium text-slate-600">{{
                                                getFromDictionary(`campaign.type.${campaign.type}`, 'label')
                                            }}</span>
                                            <div v-if="campaign.started_at" class="text-xs">
                                                {{ $filters.moment(campaign.started_at).format('MMM Do, YYYY') }}
                                            </div>
                                            <div v-else class="text-xs">No date set</div>
                                        </div>
                                    </div>
                                    <Button
                                        v-if="campaign?.is_add_in_progress === true"
                                        size="sm"
                                        disabled
                                    >
                                        <AppIcon
                                            class="my-auto mr-2 h-4 w-4 animate-spin"
                                            name="spinner-third"
                                        />
                                        <span>Adding</span>
                                    </Button>
                                    <Button
                                        v-else-if="
                                            !isMulti && isCreatorAdded('campaign', campaign.id, supercampaign.id)
                                        "
                                        size="sm"
                                        disabled
                                    >
                                        <AppIcon class="my-auto mr-2 h-4 w-4" name="check" />
                                        <span>Added</span>
                                    </Button>
                                    <Button
                                        v-else-if="
                                            !isMulti && isCreatorAlreadyAdded('campaign', campaign.id, supercampaign.id)
                                        "
                                        size="sm"
                                        disabled
                                    >
                                        <AppIcon class="my-auto mr-2 h-4 w-4" name="check" />
                                        <span>In Campaign</span>
                                    </Button>
                                    <Button
                                        v-else
                                        size="sm"
                                        :disabled="!canUnlockProfiles || totalProfilesSelected === 0"
                                        @click="onCampaignSelect(campaign)"
                                    >
                                        <AppIcon class="my-auto mr-2 h-4 w-4" name="plus" />
                                        <span>Add</span>
                                    </Button>
                                </div>

                                <div
                                    v-if="!supercampaign.campaigns || !supercampaign.campaigns.length"
                                    class="w-full border-t border-slate-200 px-6 py-2 text-center"
                                >
                                    <p>This campaign has no modules yet</p>
                                </div>
                            </div>
                        </div>

                        <div v-if="state.searchText && !filteredSupercampaigns.length" class="py-5 text-center text-sm">
                            No campaigns matching "{{ state.searchText }}"
                        </div>

                        <div
                            v-else-if="!supercampaigns.length || !filteredSupercampaigns.length"
                            class="py-5 text-center text-sm"
                        >
                            No campaigns found
                        </div>
                    </div>
                </div>

                <!-- Lists -->
                <div
                    v-if="state.activeTab === 'lists'"
                    class="mt-2 overflow-hidden overflow-y-scroll rounded border border-slate-200 scrollbar scrollbar-track-slate-200 scrollbar-thumb-slate-400 scrollbar-w-2 scrollbar-h-2 hover:scrollbar-thumb-slate-500 active:scrollbar-thumb-slate-600"
                >
                    <div class="h-96 divide-y divide-slate-200 text-sm">
                        <div class="px-5 py-3.5">
                            <div class="flex items-center justify-between">
                                <div class="flex">
                                    <div class="my-auto">
                                        <input
                                            v-model="newList.name"
                                            type="text"
                                            placeholder="Enter new list name"
                                            class="form-input w-full"
                                            :disabled="state.newList.isCreating === true"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <Tooltip
                                        max-width="500"
                                        :show-tooltip="
                                            getLimitation('lists.size') !== null &&
                                            superviews.length > getLimitation('lists.size')
                                        "
                                    >
                                        <template #trigger>
                                            <Button
                                                size="sm"
                                                :disabled="
                                                    !newList.name ||
                                                    (getLimitation('lists.size') !== null &&
                                                        superviews.length > getLimitation('lists.size'))
                                                "
                                                @click="addToNewList"
                                            >
                                                <AppIcon
                                                    v-if="state.newList.isCreating === true"
                                                    class="my-auto mr-2 h-4 w-4 animate-spin"
                                                    name="spinner-third"
                                                />
                                                <AppIcon
                                                    v-else
                                                    class="my-auto mr-2 h-4 w-4"
                                                    name="plus"
                                                />
                                                <span>Add to new list</span>
                                            </Button>
                                        </template>
                                        <template #default>
                                            {{
                                                getFromDictionary(`usage.lists.size`).replace(
                                                    '[LIMIT]',
                                                    getLimitation('lists.size'),
                                                )
                                            }}
                                        </template>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                        <div v-for="list in filteredLists" :key="list.id">
                            <div class="px-5 py-3">
                                <div class="flex items-center justify-between">
                                    <div class="flex">
                                        <div class="my-auto">
                                            <div v-if="list.name" class="line-clamp-2 font-semibold">
                                                {{ list.name }}
                                            </div>
                                            <div class="text-xs">
                                                {{ list.totals.total }} creators • Last updated
                                                {{ $filters.formatDate(list.updated_at) }}
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <Button
                                            v-if="!isMulti && list.creatorIsOnList"
                                            size="sm"
                                            disabled
                                        >
                                            <AppIcon
                                                class="my-auto mr-1.5 h-4 w-4"
                                                name="check"
                                            />
                                            <span>In List</span>
                                        </Button>
                                        <Button
                                            v-else-if="list?.is_add_in_progress === true"
                                            size="sm"
                                            disabled
                                        >
                                            <AppIcon
                                                class="my-auto mr-2 h-4 w-4 animate-spin"
                                                name="spinner-third"
                                            />
                                            <span>Adding</span>
                                        </Button>
                                        <Tooltip
                                            v-else
                                            max-width="500"
                                            :show-tooltip="
                                                list.totals.total !== -1 &&
                                                getLimitation('lists.size') !== null &&
                                                superviews.length + list.totals.total > getLimitation('lists.size')
                                            "
                                        >
                                            <template #trigger>
                                                <Button
                                                    size="sm"
                                                    :disabled="
                                                        (list.totals.total !== -1 &&
                                                        getLimitation('lists.size') !== null &&
                                                        superviews.length + list.totals.total >
                                                            getLimitation('lists.size')) || !canUnlockProfiles || totalProfilesSelected === 0
                                                    "
                                                    @click="addToList(list)"
                                                >
                                                    <AppIcon
                                                        class="my-auto mr-1.5 h-4 w-4"
                                                        name="plus"
                                                    />
                                                    <span>Add</span>
                                                </Button>
                                            </template>
                                            <template #default>
                                                {{
                                                    getFromDictionary(`usage.lists.size`).replace(
                                                        '[LIMIT]',
                                                        getLimitation('lists.size'),
                                                    )
                                                }}
                                            </template>
                                        </Tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="state.searchText && !filteredLists.length" class="py-5 text-center text-sm">
                            No lists matching "{{ state.searchText }}"
                        </div>

                        <div v-else-if="!lists.length" class="py-5 text-center text-sm">No lists found</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import Avatar from '@/components/Avatar.vue'
import NamePlate from '@/components/plates/NamePlate.vue'
import Tooltip from '@/components/Tooltip.vue'
import SkeletonAddToMenu from '../skeletons/SkeletonAddToMenu.vue'
import { trackEvent, AnalyticalEvents } from '@/utils/analytics'
import { Button } from '@/components/ui/button'

export default {
    components: {
        Avatar,
        NamePlate,
        SkeletonAddToMenu,
        Tooltip,
        Button,
    },

    props: {
        superviews: Array,
        platformId: String,
        modalOpen: Boolean,
        creatorPlatforms: {
            type: Array,
            required: true,
        },
        defaultAllPlatforms: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            state: {
                activeTab: 'recents',
                searchText: '',
                activeSupercampaignId: null,
                lists: {
                    isLoaded: false,
                },
                newList: {
                    isCreating: false,
                },
            },
            supercampaigns: [],
            lists: [],
            addToListStatus: {
                addedCreatorsMap: [],
                duplicateCreatorsMap: [],
            },
            addToCampaignStatus: {
                addedCreatorsMap: [],
                duplicateCreatorsMap: [],
            },
            results: {
                lists: {
                    addedCreators: [],
                    duplicateCreators: [],
                },
                campaigns: {
                    addedCreators: [],
                    duplicateCreators: [],
                },
                showResultsPage: false,
                resultsType: '',
                isLoading: false,
            },
            newList: {
                name: '',
                created: false,
            },
            isLoadingRemainingQuota: true,
            remainingProfileUnlockQuota: 0,
            lockedProfiles: 0,
            profilesToUnlock: [],
            selectedPlatforms: [],
        }
    },

    computed: {
        ...mapGetters([
            'getFromDictionary',
            'recentCampaignOrListAdds',
            'isSfStaff',
            'selfOperator',
            'checkPermission',
            'getLimitation',
            'selfActiveOrganizationId',
            'isLegacyBilling'
        ]),

        tabs() {
            const tabs = ['recents']

            if (this.checkPermission('feature.campaigns.manage')) {
                tabs.push('campaigns')
            }

            tabs.push('lists')

            return tabs
        },

        // determines if modal adds multiple or single creators
        isMulti() {
            if (!this.superviews) return false

            return this.superviews.length > 1
        },

        filteredLists() {
            if (!this.lists || !this.lists.length || this.state.activeTab !== 'lists') return []

            const lists = _.orderBy(this.lists, ['updated_at'], ['desc'])

            if (this.state.searchText) {
                return _.filter(
                    lists,
                    (list) => list.name && list.name.toLowerCase().includes(this.state.searchText.toLowerCase()),
                )
            }

            return lists
        },

        filteredSupercampaigns() {
            if (!this.supercampaigns || !this.supercampaigns.length || this.state.activeTab !== 'campaigns') return []

            const searchLowerCase = this.state.searchText.toLowerCase()

            return _.filter(this.supercampaigns, (supercampaign) => {
                const title = supercampaign.title ? supercampaign.title.toLowerCase() : ''
                const gameName = supercampaign.game?.name ? supercampaign.game.name.toLowerCase() : ''
                return title.includes(searchLowerCase) || gameName.includes(searchLowerCase)
            })
        },

        mappedRecents() {
            const mapped = {
                lists: {},
                supercampaigns: {},
                total: 0,
                items: [],
            }

            _.forEach(this.recentCampaignOrListAdds, (item) => {
                if (item.type === 'list') {
                    const matchedList = _.find(this.lists, (list) => {
                        return list.id === item.id
                    })
                    if (matchedList && !mapped.lists[matchedList.id]) {
                        mapped.lists[matchedList.id] = matchedList
                        mapped.items.push(item)
                        mapped.total += 1
                    }
                } else if (item.type === 'supercampaign') {
                    const matchedCampaign = _.find(this.supercampaigns, (campaign) => {
                        return campaign.id === item.id
                    })
                    if (matchedCampaign && !mapped.supercampaigns[matchedCampaign.id]) {
                        mapped.supercampaigns[matchedCampaign.id] = matchedCampaign
                        mapped.items.push(item)
                        mapped.total += 1
                    }
                }
            })

            return mapped
        },

        canUnlockProfiles() {
            return this.isLegacyBilling === true || (this.lockedProfiles <= this.remainingProfileUnlockQuota && !this.isLoadingRemainingQuota)
        },

        isProfileUnlocksLoaded() {
            return this.isLegacyBilling === true || !this.isLoadingRemainingQuota
        },

        availablePlatforms() {
            const uniquePlatforms = Array.from(
                new Set(this.creatorPlatforms.map((p) => p.platform_id))
            )
            return uniquePlatforms.sort()
        },

        totalProfilesSelected() {
            if (!this.creatorPlatforms?.length) return 0

            const isAllSelected = this.selectedPlatforms?.includes('all')
            const selectedSet = isAllSelected ? null : new Set(this.selectedPlatforms ?? [])

            return this.creatorPlatforms.filter((profile) => {
                if (isAllSelected) return true
                return profile?.platform_id && selectedSet.has(profile.platform_id)
            }).length
        },

        isAllPlatformsChecked: {
            get() {
                return this.selectedPlatforms.length === this.availablePlatforms.length
            },
            set(checked) {
                this.selectedPlatforms = checked ? [...this.availablePlatforms] : []
            },
        },
    },

    watch: {
        superviews() {
            this.onCloseModal()
            this.getSupercampaigns()
            this.state.lists.isLoaded = false
            this.getLists()
        },

        modalOpen: {
            handler(newVal) {
                if (newVal) {
                    this.initializePlatformSelection()
                }
            },
            immediate: true,
        },
    },

    async created() {
        this.getSupercampaigns()
        this.state.lists.isLoaded = false
        this.getLists()

        this.isLoadingRemainingQuota = true
        await this.fetchRemainingQuota()
        await this.checkLockedProfiles()
        this.isLoadingRemainingQuota = false

        if (!this.recentCampaignOrListAdds?.length) {
            this.state.activeTab = this.tabs[1]
        }
    },

    methods: {
        /*
            takes in a type (list or campaign) and an id (list.id or campaign.id) and returns true if the
            current creator was successfully added to the list or campaign, and false otherwise. If type is
            campaign, then provide a supercampaign_id as well. Only for SINGLE creators for now.
        */
        isCreatorAdded(type, id, supercampaignId = null) {
            if (this.isMulti) return false

            if (type === 'list') {
                const foundMap = this.addToListStatus.addedCreatorsMap.find((map) => map.list_id === id)

                if (foundMap) {
                    // eslint-disable-next-line no-underscore-dangle
                    return foundMap.creator_ids.includes(this.superviews[0]._id)
                }
            } else if (type === 'campaign') {
                const foundMap = this.addToCampaignStatus.addedCreatorsMap.find(
                    (map) => map.supercampaign_id === supercampaignId && map.campaign_id === id,
                )

                if (foundMap) {
                    // eslint-disable-next-line no-underscore-dangle
                    return foundMap.creator_ids.includes(this.superviews[0]._id)
                }
            }
            return false
        },

        /*
            takes in a type (list or campaign) and an id (list.id or campaign.id) and returns true if the
            current creator is already added to the list or campaign, and false otherwise. If type is
            campaign, then provide a supercampaign_id as well. Only for SINGLE creators for now.
        */
        isCreatorAlreadyAdded(type, id, supercampaignId = null) {
            if (this.isMulti) return false
            if (type === 'list') {
                const foundMap = this.addToListStatus.duplicateCreatorsMap.find((map) => map.list_id === id)

                if (foundMap) {
                    // eslint-disable-next-line no-underscore-dangle
                    return foundMap.creator_ids.includes(this.superviews[0]._id)
                }
            } else if (type === 'campaign') {
                const foundMap = this.addToCampaignStatus.duplicateCreatorsMap.find(
                    (map) => map.supercampaign_id === supercampaignId && map.campaign_id === id,
                )

                if (foundMap) {
                    // eslint-disable-next-line no-underscore-dangle
                    return foundMap.creator_ids.includes(this.superviews[0]._id)
                }
            }
            return false
        },

        addRecentItem(item) {
            const payload = {
                item,
            }

            this.$store.commit('recentCampaignOrListAdds:add', payload)
        },

        handleSuperCampaignClick(id) {
            if (id === this.state.activeSupercampaignId) {
                this.state.activeSupercampaignId = null
            } else {
                this.state.activeSupercampaignId = id
            }
        },

        async addToList(list) {
            this.state.searchText = ''

            const recentItem = {
                type: 'list',
                id: list.id,
            }

            this.addRecentItem(recentItem)
            return this.addCreatorsToList(list)
        },

        onCampaignSelect(campaign) {
            const supercampaign = _.find(this.supercampaigns, { id: campaign.parent_id })

            const recentItem = {
                type: 'supercampaign',
                id: supercampaign.id,
            }

            this.addRecentItem(recentItem)

            // api call
            this.addCreatorsToCampaign(campaign)
        },

        setActiveTab(tab) {
            if (tab === this.state.activeTab) return

            this.state.activeSupercampaignId = null
            this.state.activeTab = tab
            this.state.searchText = ''
        },

        async addCreatorsToList(list) {
            list.is_add_in_progress = true

            const platformsToAdd = this.selectedPlatforms.includes('all')
                ? _.uniq(this.creatorPlatforms.map((p) => p.platform_id))
                : this.selectedPlatforms

            try {
                for (const platformId of platformsToAdd) {
                    const creatorsForPlatform = this.creatorPlatforms
                        .filter((p) => p.platform_id === platformId)
                        .map((p) => ({
                            platform_user_id: p.id,
                            platform_id: p.platform_id,
                        }))

                    if (creatorsForPlatform.length === 0) continue

                    const { data } = await this.$axios.post(
                        `/lists/${list.id}/creators`,
                        { creators: creatorsForPlatform }
                    )

                    const { count, results } = data.payload

                    const insertions = _.flatten(_.map(results, 'new_creators'))
                    const duplicates = _.filter(
                        _.flatten(_.map(results, 'staged_insertions')),
                        (item) => item.status === 'duplicate'
                    )

                    if (this.isMulti) {
                        if (count > 0) {
                            const addedMap = {
                                list_id: list.id,
                                creator_ids: _.map(insertions, 'superview._id'),
                            }
                            this.addToListStatus.addedCreatorsMap.push(addedMap)
                            this.results.lists.addedCreators.push(...insertions)
                        }

                        if (duplicates?.length > 0) {
                            const duplicateMap = {
                                list_id: list.id,
                                creator_ids: _.map(duplicates, 'list_creator.platform_user_id'),
                            }

                            const duplicateSuperviews = duplicates.map((creator) => {
                                const superview = this.superviews.find(
                                    (view) => view._id === creator.platform_user_id
                                )
                                return superview ? { superview: { ...superview } } : null
                            })

                            this.addToListStatus.duplicateCreatorsMap.push(duplicateMap)
                            this.results.lists.duplicateCreators.push(...duplicateSuperviews)
                        }

                        this.results.resultsType = 'list'
                        this.results.showResultsPage = true
                    } else {
                        if (count === 0 && duplicates?.length > 0) {
                            const duplicateMap = {
                                list_id: list.id,
                                creator_ids: duplicates.map(
                                    (creator) => creator.platform_user_id
                                ),
                            }
                            this.addToListStatus.duplicateCreatorsMap.push(duplicateMap)
                        } else if (count === 1) {
                            const addedMap = {
                                list_id: list.id,
                                creator_ids: insertions.map(
                                    (creator) => creator.superview._id
                                ),
                            }
                            this.addToListStatus.addedCreatorsMap.push(addedMap)
                        }
                    }

                    if (
                        data.payload.instagram_stories_fetch_triggered &&
                        data.payload.instagram_stories_fetch_count > 0
                    ) {
                        const storiesCount = data.payload.instagram_stories_fetch_count
                        const creatorsText = storiesCount === 1 ? 'creator' : 'creators'

                        this.$notify({
                            type: 'info',
                            title: 'Fetching Instagram Stories',
                            text: `Loading stories for ${storiesCount} Instagram ${creatorsText}. This may take up to 30 seconds per Instagram profile added.`,
                            duration: 5000,
                        })
                    }
                }

                await this.unlockProfiles()
                await this.getLists()
            } catch (error) {
                this.$errorHandler(error, {
                    title: 'Adding Creators',
                    message:
                        error.response?.status === 400
                            ? error.response.data.message
                            : 'Error adding creator to list.',
                })
            } finally {
                list.is_add_in_progress = false
            }
        },


        async addCreatorsToCampaign(campaign) {
            campaign.is_add_in_progress = true

            const platformsToAdd = this.selectedPlatforms.includes('all')
                ? _.uniq(this.creatorPlatforms.map((p) => p.platform_id))
                : this.selectedPlatforms

            try {
                for (const platformId of platformsToAdd) {
                    const creatorsForPlatform = this.creatorPlatforms
                        .filter((p) => p.platform_id === platformId)
                        .map((p) => ({
                            platform_user_id: p.id,
                            platform_id: p.platform_id,
                        }))

                    if (creatorsForPlatform.length === 0) continue

                    const { data } = await this.$axios.post(
                        `/supercampaigns/${campaign.parent_id}/campaigns/${campaign.id}/participants`,
                        { creators: creatorsForPlatform }
                    )

                    const { count, duplicateCampaignParticipants, participants } = data.payload

                    if (this.isMulti) {
                        if (count > 0) {
                            const addedMap = {
                                campaign_id: campaign.id,
                                supercampaign_id: campaign.parent_id,
                                creator_ids: participants.map(
                                    (creator) => creator.superview._id
                                ),
                            }
                            this.addToCampaignStatus.addedCreatorsMap.push(addedMap)
                            this.results.campaigns.addedCreators.push(...participants)
                        } else if (
                            duplicateCampaignParticipants &&
                            duplicateCampaignParticipants.length > 0
                        ) {
                            const duplicateMap = {
                                campaign_id: campaign.id,
                                supercampaign_id: campaign.parent_id,
                                creator_ids: duplicateCampaignParticipants.map(
                                    (creator) => creator.platform_user_id
                                ),
                            }

                            const duplicateSuperviews = duplicateCampaignParticipants.map(
                                (creator) => {
                                    const superview = this.superviews.find(
                                        (view) => view._id === creator.platform_user_id
                                    )
                                    return superview ? { superview: { ...superview } } : null
                                }
                            )

                            this.addToCampaignStatus.duplicateCreatorsMap.push(duplicateMap)
                            this.results.campaigns.duplicateCreators.push(...duplicateSuperviews)
                        }

                        this.results.resultsType = 'campaign'
                        this.results.showResultsPage = true
                    } else {
                        if (count === 0 && duplicateCampaignParticipants?.length > 0) {
                            const duplicateMap = {
                                campaign_id: campaign.id,
                                supercampaign_id: campaign.parent_id,
                                creator_ids: duplicateCampaignParticipants.map(
                                    (creator) => creator.platform_user_id
                                ),
                            }
                            this.addToCampaignStatus.duplicateCreatorsMap.push(duplicateMap)
                        } else if (count === 1) {
                            const addedMap = {
                                campaign_id: campaign.id,
                                supercampaign_id: campaign.parent_id,
                                creator_ids: participants.map(
                                    (creator) => creator.platform_user_id
                                ),
                            }
                            this.addToCampaignStatus.addedCreatorsMap.push(addedMap)
                        }
                    }
                }

                await this.unlockProfiles()
            } catch (error) {
                console.error(error)
                this.$errorHandler(error, {
                    title: 'Adding Creators',
                    message: 'Error adding creator to campaign.',
                })
            } finally {
                campaign.is_add_in_progress = false
            }
        },

        getLists() {
            let params = null

            if (this.superviews && this.superviews.length === 1) {
                params = {
                    platform_user_id: this.superviews[0]._id,
                    platform_id: this.platformId,
                }
            }

            return this.$axios
                .get('/lists', {
                    params,
                })
                .then(({ data }) => {
                    this.lists = _.orderBy(
                        [...data.payload.myLists, ...data.payload.sharedLists],
                        ['updated_at'],
                        ['desc'],
                    )
                    this.state.lists.isLoaded = true
                })
                .catch((error) => {
                    console.log(error)
                })
        },

        getSupercampaigns() {
            this.$axios
                .get('/supercampaigns', {
                    params: {
                        relations: ['games', 'campaigns'],
                    },
                })
                .then(({ data }) => {
                    this.supercampaigns = _(data.payload.supercampaigns).orderBy(['created_at'], ['desc']).value()
                })
                .catch((error) => {
                    this.$errorHandler(error, {
                        title: 'Supercampaigns',
                        message: 'Error fetching supercampaigns.',
                    })
                })
        },

        handleAddClick(list) {
            this.addToList(list)

            if (this.lockedProfiles > 0) {
                trackEvent(AnalyticalEvents.ProfileUnlocked, {
                    creator_count: this.lockedProfiles,
                    origin: 'Add to list',
                })
            }
        },

        addToNewList() {
            // Trigger new list created event
            trackEvent(AnalyticalEvents.ListCreated, {
                list_name: this.newList.name,
            })

            if (this.lockedProfiles > 0) {
                trackEvent(AnalyticalEvents.ProfileUnlocked, {
                    creator_count: this.lockedProfiles,
                    origin: 'Add to list',
                })
            }

            this.state.newList.isCreating = true

            const list = {
                name: this.newList.name,
                operator_id: this.selfOperator.id,
            }

            this.$axios
                .post('/lists', {
                    list,
                })
                .then(async ({ data }) => {
                    const newList = data.payload.list

                    this.lists.unshift(newList)

                    await this.addToList(newList)
                    this.newList.created = true
                    this.state.newList.isCreating = false
                    this.newList.name = ''
                    return this.$successHandler('Successfully created list with selected creators.')
                })
                .catch((error) => {
                    this.state.newList.isCreating = false
                    this.$errorHandler(error, {
                        title: 'Creating new list',
                        message: 'Error creating new list.',
                    })
                })
        },

        onCloseModal() {
            // reset state

            this.state = {
                activeTab: 'recents',
                searchText: '',
                activeSupercampaignId: null,
            }
            this.addToListStatus = {
                addedCreatorsMap: [],
                duplicateCreatorsMap: [],
            }
            this.addToCampaignStatus = {
                addedCreatorsMap: [],
                duplicateCreatorsMap: [],
            }
            this.results = {
                lists: {
                    addedCreators: [],
                    duplicateCreators: [],
                },
                campaigns: {
                    addedCreators: [],
                    duplicateCreators: [],
                },
                showResultsPage: false,
                resultsType: '',
                isLoading: false,
            }
        },

        async fetchRemainingQuota() {
            const quotas = await this.$store.dispatch('fetchRemainingQuota', { organizationId: this.selfActiveOrganizationId })
            this.remainingProfileUnlockQuota = quotas['profile-unlock']
        },

        async checkLockedProfiles() {
            const creators = _.map(this.superviews, (creator) => {
                return ['superview', creator.platform_id, creator._id]
            })

            const statusChecks = await this.$store.dispatch('bulkFetchRevealStatus', {
                quotaType : 'profile-unlock',
                items : creators,
            })

            this.profilesToUnlock = _.filter(statusChecks, (item) =>
                item?.payload?.is_revealable === true && item?.payload?.is_previously_unlocked === false)

            this.lockedProfiles = this.profilesToUnlock.length
        },

        async unlockProfiles() {
            _.forEach(this.profilesToUnlock, async profile => {
                await this.$store.dispatch('reveal', {
                    quotaType : 'profile-unlock',
                    keyIds : [profile.resourceType].concat(profile.resourceId.split(':'))
                })
            })

            this.profilesToUnlock = []
            this.isLoadingRemainingQuota = true
            await this.fetchRemainingQuota()
            await this.checkLockedProfiles()
            this.isLoadingRemainingQuota = false
        },

        initializePlatformSelection() {
            if (this.defaultAllPlatforms) {
                this.selectedPlatforms = [...this.availablePlatforms]
            } else if (this.platformId && this.availablePlatforms.includes(this.platformId)) {
                this.selectedPlatforms = [this.platformId]
            } else {
                this.selectedPlatforms = []
            }
        },
    },
}
</script>